const appConfig = key => process.env[key];

export default appConfig;



// WEBPACK FOOTER //
// ./src/config/appConfig.js